// extracted by mini-css-extract-plugin
export default {"mask":"redeemPage_mask__xEZAN","sortAsc":"redeemPage_sortAsc__sE+ZI","sortDesc":"redeemPage_sortDesc__R7sKZ"};